module.exports = __webpack_public_path__ + "img/cover-kim-kaey.5b4ddd6c.png";